<div class="bmc-excel-connector-item-detail" *ngIf="selectedConnector && selectedConnector.name" [ngClass]="{'bmc-excel-connector-item-detail__hidden': isLoading || isUploading}">

    <div class="bz-space--stack-l bmc-excel-connector-item-detail__header">
        <h4 class="bmc-excel-connector-item-detail__title">{{selectedConnector.name}}</h4>
    </div>
    <div class="bmc-excel-connector-item-detail__content">
        <div class="bmc-excel-connector-item-detail__file-section bz-space--stack-m">
            <div class="bmc-excel-connector-item-detail__version bz-space--inline-s">
                <div class="bz-space--stack-xs">
                    <strong>{{'EXCEL_CONNECTOR.SELECT_A_VERSION' | translate}}</strong>
                </div>
                <bzg-select [placeholder]="'GLOBAL.NONE' | translate" [(value)]="selectedConnectorChild"
                    (valueChange)="onVersionChanged($event)">
                    <bzg-option *ngFor="let childrenItem of selectedConnector.children" [value]="childrenItem">
                        {{ childrenItem.version }}</bzg-option>
                </bzg-select>
            </div>
            <div class="bmc-excel-connector-item-detail__file">
                <div class="bmc-excel-connector-item-detail__file-input bz-space--inline-s">
                    <bzg-input actionIcnPosition="right" [(ngModel)]="fileName" [disabled]="true">
                        {{'EXCEL_CONNECTOR.EXCEL_FILE' | translate}}
                        <bzg-icon nameIcon="icon-download" (click)="onDownload()"
                            class="bmc-excel-connector-item-detail__file-download"></bzg-icon>
                    </bzg-input>
                </div>
                <bzg-button-secondary [icon]="'icon-upload'" (click)="excelUploaderInput.click()" [disabled]="!selectedVersionDetail">
                    {{'EXCEL_CONNECTOR.UPLOAD_FILE' | translate}}
                </bzg-button-secondary>
                <form #formFile>
                    <input hidden type="file" #excelUploaderInput accept=".xlsx,.xls,.xlsb" filters=".xlsx,.xls,.xlsb"
                        (change)="onUploadFile($event)" />
                </form>
                
            </div>
        </div>
        <div *ngIf="selectedVersionDetail" class="bz-space--stack-xl">
            <strong
                class="bmc-excel-connector-item-detail__description bz-space--stack-xs">{{'EXCEL_CONNECTOR.DESCRIPTION' | translate}}</strong>
            <p>{{selectedVersionDetail ? selectedVersionDetail.description : ''}}</p>
        </div>
        <h4 *ngIf="selectedVersionDetail" class="bz-space--stack-m">{{'EXCEL_CONNECTOR.ACTIONS' | translate}}</h4>
        <ul *ngIf="selectedVersionDetail" class="bmc-excel-connector-item-detail-actions">
            <li class="bmc-excel-connector-item-detail-actions__action"
                *ngFor="let action of selectedVersionDetail.actions">
                <div class="bmc-excel-connector-item-detail-actions__header"
                    [ngClass]="{'bmc-excel-connector-item-detail-actions__header--open bz-color-bg--neutral-200': selectedAction?.actionname === action.actionname}">
                    <strong>{{ action.actionname }}</strong>
                    <div class="bmc-excel-connector-item-detail-actions__header-info">
                        <span>{{'EXCEL_CONNECTOR.SHEET_NAME' | translate}}: {{ action.sheetname }}</span>
                        <div class="bmc-excel-connector-item-detail-actions__separator"></div>
                        <span>{{'EXCEL_CONNECTOR.TYPE' | translate}}: {{ action.actiontype.charAt(0).toUpperCase() + (action.actiontype.slice(1)).toLowerCase() }}</span>
                    </div>
                    <div class="bmc-excel-connector-item-detail-actions__icon-arrow-container"
                        [ngClass]="{'bmc-excel-connector-item-detail-actions__icon-arrow-container--selected': selectedAction?.actionname === action.actionname}">
                        <bzg-icon class="bmc-excel-connector-item-detail-actions__icon-arrow"
                            (click)="onSelectAction(action)"
                            [nameIcon]="selectedAction?.actionname === action.actionname ? 'icon-arrow-up-table' : 'icon-arrow-down-table'" [size]="16">
                        </bzg-icon>
                    </div>
                </div>
                <div class="bmc-excel-connector-item-detail-actions__content" *ngIf="selectedAction?.actionname === action.actionname">
                    <div class="bmc-excel-connector-item-detail-actions__container-action" *ngIf="action.actiontype === 'WRITE'">
                        <div class="bz-space--stack-m">
                            <div class="bz-space--stack-m">
                                <h4><strong>{{'EXCEL_CONNECTOR.INPUTS' | translate}}</strong></h4>
                            </div>
                            <div class="bmc-excel-connector-item-detail-actions__action-inputs-info bz-space--stack-m" *ngFor="let input of action.inputs; let inputIdx=index">
                                <div class="bmc-excel-connector-item-detail-actions__write-field">
                                    <strong>{{'EXCEL_CONNECTOR.NAME' | translate}}</strong>
                                    <span>{{ input.cell[0] === '@' ? input.cell.split('@')[0] : input.cell.split('@')[1] }}</span>
                                </div>
                                <div class="bmc-excel-connector-item-detail-actions__write-field">
                                    <strong>{{'EXCEL_CONNECTOR.TYPE' | translate}}</strong>
                                    <span>{{ input.value }}</span>
                                </div>
                                <div class="bmc-excel-connector-item-detail-actions__write-field">
                                    <strong>{{'EXCEL_CONNECTOR.CELL_TYPE' | translate}}</strong>
                                    <span *ngIf="input.subType >= 0"> {{  ('EXCEL_CONNECTOR.' + eCellActionType[input.subType]) | translate }}</span>
                                </div>
                                <div class="bmc-excel-connector-item-detail-actions__write-field">
                                    <strong>{{'EXCEL_CONNECTOR.CELL' | translate}}</strong>
                                    <span *ngIf="input.subType >= 0">{{ ( input.subType === eCellActionType.CELL_COORDINATE ) 
                                        ? ( input.cell[0] === '@' ? '' :  (input.cell.split('@')[0] ? input.cell.split('@')[0] : '') )
                                        : (input.rangeName.name+' ('+input.rangeName.coordinates+')') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bmc-excel-connector-item-detail-actions__container-action" *ngFor="let input of action.inputs; let inputIdx=index">
                        <ng-container *ngIf="action.actiontype !== 'WRITE'">
                            <div class="bz-space--stack-m">
                                <h4><strong>{{'EXCEL_CONNECTOR.CELL_DEFINITION' | translate}}</strong></h4>
                            </div>
                            <div class="bmc-excel-connector-item-detail-actions__fields" >
                                <div class="bmc-excel-connector-item-detail-actions__write-field">
                                    <strong>{{'EXCEL_CONNECTOR.CELL_TYPE' | translate}}</strong>
                                    <span> {{ ('EXCEL_CONNECTOR.' + eCellActionType[input.subType]) | translate  }}</span>
                                </div>
                                <div class="bmc-excel-connector-item-detail-actions__write-field"  
                                    *ngIf="action.actiontype === 'READ RANGE' || action.actiontype === 'WRITE RANGE'">
                                        <strong>{{'EXCEL_CONNECTOR.CELL_RANGE' | translate}}</strong>
                                        <span>{{ input.range }}</span>
                                </div>
                                <div class="bmc-excel-connector-item-detail-actions__write-field"  *ngIf="action.actiontype === 'READ CELL'">
                                    <strong>{{'EXCEL_CONNECTOR.CELL' | translate}}</strong>
                                    <span>{{ (input.subType === eCellActionType.CELL_COORDINATE) 
                                        ? ( input.cell[0] === '@' ? '' : input.cell.split('@')[0] )
                                        : (input.rangeName.name+' ('+input.rangeName.coordinates+')') }}
                                    </span>
                                </div>
                                <div class="bmc-excel-connector-item-detail-actions__field" *ngIf="action.actiontype === 'READ CELL'">
                                    <strong>{{'EXCEL_CONNECTOR.RETURN_TYPE' | translate}}</strong>
                                    <span>{{ action.outputs[inputIdx].result }}</span>
                                </div>
                                <div class="bmc-excel-connector-item-detail-actions__field"
                                    *ngIf="action.actiontype === 'READ RANGE' || action.actiontype === 'WRITE RANGE'">
                                        <strong>{{'EXCEL_CONNECTOR.RANGE_COLUMNS' | translate}}</strong>
                                        <span>{{ distanceBetweenColumns(input.range) }} {{ 'GLOBAL.COLUMNS' | translate }}</span>
                                </div>
                            </div>
                            <div *ngIf="action.actiontype === 'READ RANGE' || action.actiontype === 'WRITE RANGE'">
                                <h4><strong>{{'EXCEL_CONNECTOR.COLUMN_DEFINITION' | translate}}</strong></h4>
                                <div class="bmc-excel-connector-item-detail-actions__column-definition">
                                    <div class="bmc-excel-connector-item-detail-actions__column"
                                        *ngFor="let propertyName of getColumnsDefinition(action.outputs[inputIdx]); let i=index"
                                        [ngClass]="{'bmc-excel-connector-item-detail-actions__column--separator': i == 0 || i % 2 == 0}">
                                        <div class="bmc-excel-connector-item-detail-actions__column-info">
                                            <strong>{{'EXCEL_CONNECTOR.NAME' | translate}}</strong>
                                            <span> {{ propertyName }}</span>
                                        </div>
                                        <div class="bmc-excel-connector-item-detail-actions__column-info">
                                            <strong>{{'EXCEL_CONNECTOR.TYPE' | translate}}</strong>
                                            <span>{{ action.outputs[inputIdx][propertyName] }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div class="bmc-excel-connector-item-detail__buttons bz-space--stack-m">
        <bzg-button-secondary class="bz-space--inline-m" (click)="onCancel()">{{'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
        <bzg-button-primary (click)="onSave()">{{'GLOBAL.SAVE' | translate}}</bzg-button-primary>
    </div>
</div>
<bz-loading [size]="'m'" class="bzg-loading-connect-excel" *ngIf="isLoading">
    {{ 'GLOBAL.LOADING_DATA' | translate }}</bz-loading>
<bz-loading [size]="'m'" class="bzg-loading-connect-excel" *ngIf="isUploading">
    {{ 'EXCEL_CONNECTOR.EXCEL_UPLOADING' | translate }}</bz-loading>
<div class="bmc-excel-connector-item-detail__not-selected">
    <ng-content></ng-content>
</div>